import React, { useEffect, useState } from "react";
import "./CrmDetailPage.scss";
import CustomTextField from "../../../TextFiled/Index";
import { Card, CardContent, CircularProgress, MenuItem } from "@mui/material";
import CrmMain from "./CrmMain/CrmMain";
import DesignWiseSale from "./DesignWiseSale/DesignWiseSale";
import { CRMCustomerLog } from "../../../../Utils/API/CRMCustomerLog/CRMCustomerLog";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Bar, PolarArea } from "react-chartjs-2";

const CrmDetailPage = (props) => {
  const { labelColor, borderColor, legendColor } = props;

  const [selectedMetal, setSelectedMetal] = useState("Call");
  const [isSticky, setIsSticky] = useState(false);

  let HeaderName = sessionStorage.getItem("CustomerFLname_CRMCall");
  let HeaderNameCode = sessionStorage.getItem("CustomerCode_CRMCall");

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedMetal(selectedValue);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 56) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [callLogs, setCallLogs] = useState([]);

  useEffect(() => {
    let CustomerId = sessionStorage.getItem("CustomerId_CRMCall");
    setIsLoading(true);
    CRMCustomerLog("CRM_Customer_CallLog", CustomerId)
      .then((response) => {
        setIsLoading(false);
        if (response?.Data?.DT) {
          setCallLogs(response.Data.DT);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API Error:", err);
      });
  }, []);

  //crmmain.................................................
  const [categoryData, setCategoryData] = useState({
    labels: [],
    data: [],
  });
  const [paymentData, setPaymentData] = useState([]);
  const [monthlySaleChartData, setMonthlySaleChartData] = useState([]);
  const [lasrOrderData, setLasrOrderData] = useState([]);

  useEffect(() => {
    let CustomerId = sessionStorage.getItem("CustomerId_CRMCall");
    // setIsLoading(true);
    CRMCustomerLog("CRM_Customer_CategoryWiseSale", CustomerId)
      .then((response) => {
        setIsLoading(false);
        if (response.Status === "200" && response.Data?.DT?.length) {
          const categories = response.Data.DT.map((item) => item.Category);
          const salesAmount = response.Data.DT.map((item) => item.SaleAmount);
          setCategoryData({
            labels: categories,
            data: salesAmount,
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API Error:", err);
      });

    CRMCustomerLog("CRM_Customer_LastThree_Order_Payment", CustomerId)
      .then((response) => {
        setIsLoading(false);
        if (response.Status === "200" && response.Data?.DT1?.length) {
          setPaymentData(response.Data.DT1);
        }

        if (response.Status === "200" && response.Data?.DT?.length) {
          setLasrOrderData(response.Data.DT);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API Error:", err);
      });

    CRMCustomerLog("CRM_Customer_SaleChart", CustomerId)
      .then((response) => {
        setIsLoading(false);
        if (response.Data?.DT) {
          setMonthlySaleChartData(response.Data.DT);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API Error:", err);
      });
  }, []);

  const dataPolar = {
    labels: categoryData.labels,
    datasets: [
      {
        data: categoryData.data,
        backgroundColor: [
          "lightgray", // Red
          "yellow", // Green
          "lightpink", // Blue
          "rgb(111 241 125 / 87%)", // Pink
          "#FF9633", // Orange
        ],
        borderWidth: 1,
      },
    ],
  };

  const optionsPolar = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        grid: {
          display: false, // Hides the circular grid lines
        },
        angleLines: {
          display: false, // Hides the radial lines
        },
        ticks: {
          display: false, // Hides the tick marks
        },
        pointLabels: {
          display: true, // Keep point labels visible
          color: labelColor,
        },
        pointLabels: {
          display: false, // Show the labels
          color: labelColor,
        },
      },
    },
    plugins: {
      legend: {
        position: "right",
        align: "end",
        labels: {
          padding: 25,
          boxWidth: 9,
          color: legendColor,
          usePointStyle: true
        }
      },
    },
  };

  const optionsD = {
    indexAxis: "x",
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 500 },
    elements: {
      bar: {
        borderRadius: {
          topRight: 15,
          topLeft: 15,
        },
      },
    },
    layout: {
      padding: { top: -4 },
    },
    scales: {
      x: {
        grid: {
          drawTicks: false,
        },
      },
      y: {
        min: 0,
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        align: "end",
        position: "top",
      },
    },
  };

  const dataD = {
    labels: monthlySaleChartData?.map((item) => item.Month_Name),
    datasets: [
      {
        maxBarThickness: 15,
        label: "Sale",
        backgroundColor: "rgb(255, 159, 67)",
        borderColor: "transparent",
        data: monthlySaleChartData?.map((item) => item.SaleAmount),
      },
    ],
  };

  //crmDesign.........................................................
  const [designData, setDesignData] = useState([]);

  const checkImageAvailability = (imagePath, defImage) => {
    const img = new Image();
    img.onload = () => {
      return imagePath;
    };
    img.onerror = () => {
      return defImage;
    };
    img.src = imagePath;
    return defImage;
  };

  useEffect(() => {
    let CustomerId = sessionStorage.getItem("CustomerId_CRMCall");
    // setIsLoading(true);
    CRMCustomerLog("CRM_Customer_DesignWiseSale", CustomerId ?? "")
      .then((response) => {
        setIsLoading(false);
        if (response.Status === "200" && response.Data?.DT) {
          setDesignData(response.Data.DT);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  }, []);

  return (
    <div>
      {/* {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )} */}
      <div>
        <div className={`crm_topSection ${isSticky ? "sticky" : ""}`}>
          <p style={{ fontWeight: 600, fontSize: "15px" }}>
            {HeaderName} {HeaderNameCode && `(${HeaderNameCode})`}
          </p>
          <CustomTextField
            select
            size="small"
            variant="filled"
            className="allCustomize_textinput"
            value={selectedMetal}
            onChange={handleDropdownChange}
          >
            <MenuItem value="Call" defaultChecked>
              Calls
            </MenuItem>
            <MenuItem value="CRM">CRM</MenuItem>
            <MenuItem value="DesignWiseSales">Design wise sales</MenuItem>
          </CustomTextField>
        </div>

        <div>
          {selectedMetal == "Call" && (
            <div style={{ margin: "5px" }}>
              {!isLoading &&
                (callLogs?.length !== 0 ? (
                  <table style={{ width: "100%", backgroundColor: "white" }}>
                    <thead>
                      <tr className="headerTable">
                        <th colSpan={4}>Call Logs</th>
                      </tr>
                    </thead>
                    <tbody>
                      {callLogs?.map((log, index) => (
                        <tr
                          key={index}
                          className={
                            index % 2 === 0
                              ? "tableRowMain"
                              : "tableRowMain_one"
                          }
                        >
                          <td className="crm_callLog_table_Row_data_Eror">
                            {log?.CallStatus === 1 ? (
                              <FaArrowRight style={{ color: " #97c641" }} />
                            ) : (
                              <FaArrowLeft style={{ color: "#1498e2" }} />
                            )}
                          </td>
                          <td className="crm_callLog_table_Row_data">
                            {log?.CallDate}
                          </td>
                          <td className="crm_callLog_table_Row_data_Customer">
                            {log?.CustomerName}
                          </td>
                          <td className="crm_callLog_table_Row_data_Note">
                            {log?.FullSpecialNote || "No special note"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "250px",
                    }}
                  >
                    <p style={{ fontSize: "15px", fontWeight: 600 }}>
                      No Data Available
                    </p>
                  </div>
                ))}
            </div>
          )}

          {selectedMetal == "CRM" && (
            <div>
              {!isLoading &&
                (paymentData?.length !== 0 ||
                lasrOrderData?.length !== 0 ||
                monthlySaleChartData?.length !== 0 ||
                categoryData?.data?.length !== 0 ? (
                  <div style={{ margin: "5px" }}>
                    {lasrOrderData?.length !== 0 && (
                      <div style={{ margin: "25px 5px 0px 5px" }}>
                        <table
                          style={{ width: "100%", backgroundColor: "white" }}
                        >
                          <tr className="headerTable">
                            <th colSpan={2}>Last Three Order</th>
                          </tr>

                          {lasrOrderData?.map((payment, index) => (
                            <tr
                              key={payment.SrNo}
                              className={
                                index % 2 === 0
                                  ? "tableRowMain"
                                  : "tableRowMain_one"
                              }
                            >
                              <td className="crm_lastOrder_data">
                                {payment.JobVersionNo}
                              </td>
                              <td className="crm_lastOrder_data">
                                {" "}
                                {payment.categorycode}
                              </td>
                              <td className="crm_lastOrder_data">
                                {payment.ProgressStatusName}
                              </td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    )}

                    {paymentData?.length !== 0 && (
                      <div style={{ margin: "25px 5px 0px 5px" }}>
                        <table
                          style={{ width: "100%", backgroundColor: "white" }}
                        >
                          <tr className="headerTable">
                            <th colSpan={4}>Last Three Payment</th>
                          </tr>
                          {paymentData.map((payment, index) => (
                            <tr
                              key={payment.SrNo}
                              className={
                                index % 2 === 0
                                  ? "tableRowMain"
                                  : "tableRowMain_one"
                              }
                            >
                              <td className="crm_lastOrder_data">
                                {index + 1}
                              </td>
                              <td className="crm_lastOrder_data">
                                ₹ {payment.Amount}
                              </td>
                              <td className="crm_lastOrder_data">
                                {payment.PaymentDate}
                              </td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    )}

                    {categoryData?.data?.length !== 0 && (
                      <div style={{ margin: "10px 5px 0px 5px" }}>
                        <Card>
                          <CardContent>
                            <PolarArea
                              data={dataPolar}
                              height={250}
                              options={optionsPolar}
                            />
                          </CardContent>
                          <p
                            style={{
                              margin: "10px 10px",
                              fontWeight: 600,
                              textAlign: "center",
                              color: "black",
                            }}
                          >
                            Category Wise Sales
                          </p>
                        </Card>
                      </div>
                    )}

                    {monthlySaleChartData?.length !== 0 && (
                      <div style={{ margin: "10px 5px 0px 5px" }}>
                        <Card>
                          <CardContent>
                            <Bar data={dataD} height={250} options={optionsD} />
                          </CardContent>
                          <p
                            style={{
                              margin: "10px 10px",
                              fontWeight: 600,
                              textAlign: "center",
                              color: "black",
                            }}
                          >
                            Monthly Sales
                          </p>
                        </Card>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "250px",
                    }}
                  >
                    <p style={{ fontSize: "15px", fontWeight: 600 }}>
                      No Data Available
                    </p>
                  </div>
                ))}
            </div>
          )}

          {selectedMetal == "DesignWiseSales" && (
            <div className="crm_design_weise_sale_main">
              {!isLoading &&
                (designData?.length !== 0 ? (
                  designData.map((design, index) => {
                    const imageSrc = design.ImagePath || design.DefImage;
                    // const imageSrc = checkImageAvailability(
                    //   design.ImagePath,
                    //   design.DefImage
                    // );
                    return (
                      <div key={index} className="designBox_div">
                        <img
                          src={imageSrc}
                          className="crmDEsignWise_img"
                          alt={`Design ${design.DesignNo}`}
                          onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = design.DefImage; // Set default image if loading fails
                          }}
                        />
                        <div style={{ padding: "5px" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <p className="image_designNumber">
                              {design.DesignNo}
                            </p>
                            <p className="image_Extra_title">
                              NetWt: <span>{design.DesignNetWt}</span>
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <p className="image_Extra_title">
                              Dia Wt: <span>{design.DiamondWt}</span>
                            </p>
                            <p className="image_Extra_title">
                              Cs Wt: <span>{design.ColorstoneWt}</span>
                            </p>
                          </div>
                          <div>
                            <p className="image_Extra_title">
                              Purchase Count: <span>{design.SalesCnt}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "250px",
                      width: "100%",
                    }}
                  >
                    <p style={{ fontSize: "15px", fontWeight: 600 }}>
                      No Data Available
                    </p>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CrmDetailPage;
